import { useSuspenseQuery } from '@tanstack/react-query';

import {
  getDictionaryValidationOptions,
  useValidateDictionary,
} from '@/module/Author/Dictionary/Validation/model/DictionaryValidationModel';

import { Id, useAppNotification } from '@feature/utils';
import { ValidationRequest, ValidationVariant } from '@feature/validation';
import { ValidationAction } from '@feature/validation/ValidationAction';

interface ValidationActionProps {
  dictionaryId: Id;
  variant?: ValidationVariant;
}

export function DictionaryValidationAction({ dictionaryId, variant }: ValidationActionProps) {
  const { data } = useSuspenseQuery(getDictionaryValidationOptions(dictionaryId));
  const notification = useAppNotification();
  const { mutate, isPending } = useValidateDictionary(dictionaryId);

  const onSubmit = (request: ValidationRequest) => {
    mutate(request, {
      onSuccess: notification.success,
      onError: notification.error,
    });
  };

  return (
    <ValidationAction
      validation={data}
      isPending={isPending}
      onSubmit={onSubmit}
      variant={variant}
    />
  );
}
